import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  getNotificationLoading: false,
  total: 0,
  notiCount: 0,
  unreadCount: 0,
  notifications: [],
  readNotification: [],
  readAllNotifications: false,
};

export const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    setNotificationLoading(state, action) {
      return {
        ...state,
        getNotificationLoading: action?.payload,
      };
    },
    setNotifications(state, action) {
      return {
        ...state,
        getNotificationLoading: false,
        notifications: action.payload.notifications,
        total: action.payload.total,
        notiCount: action.payload.notLength,
        unreadCount: action.payload.unreadCount
      };
    },
    setNotificationsCount(state, action) {
      return {
        ...state,
        notiCount: action.payload.notLength,
      };
    },
    setReadNotification(state, action) {
      return {
        ...state,
        readNotification: action.payload,
      };
    },
    setReadAllNotifications(state, action) {
      return {
        ...state,
        readAllNotifications: action.payload,
      };
    },
  },
});

export const {
  setNotificationLoading,
  setNotifications,
  setNotificationsCount,
  setReadNotification,
  setReadAllNotifications
} = notificationSlice.actions;
export default notificationSlice.reducer;
